import Switch from "react-switch";

interface SntOnOffSwitchProps {
  checked: boolean;
  onChange?: (checked: boolean) => void;
  disabled?: boolean;
  className?: string;
  title?: string;
}

const SntOnOffSwitch = ({
  checked,
  onChange,
  disabled,
  className = "",
  title,
}: SntOnOffSwitchProps) => {
  const handleChange = (checked: boolean) => {
    onChange?.(checked);
  };

  return title ? (
    <div
      className={`${className}`}
      style={{
        alignItems: "center",
        display: "flex",
        justifyContent: "space-between",
      }}
    >
      <span className="me-1">{title}</span>
      <Switch
        checked={checked}
        onChange={handleChange}
        disabled={disabled}
        height={20}
        width={40}
        handleDiameter={16}
      />
    </div>
  ) : (
    <label className={`${className}`}>
      <Switch
        checked={checked}
        onChange={handleChange}
        disabled={disabled}
        height={20}
        width={40}
        handleDiameter={16}
      />
    </label>
  );
};

export default SntOnOffSwitch;
